/* BBG category-circles portu — bağımsız vanilla JS (ok gezinmesi). Önek: bbgcc- */
(function () {
  'use strict';

  if (customElements.get('bbg-category-circles')) return;

  class BbgCategoryCircles extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.bbgcc-track');
      this.prevBtn = this.querySelector('.bbgcc-arrow--prev');
      this.nextBtn = this.querySelector('.bbgcc-arrow--next');
      if (!this.track || !this.prevBtn || !this.nextBtn) return;

      this._onPrev = () => this.scrollByStep(-1);
      this._onNext = () => this.scrollByStep(1);
      this._onScroll = () => this.update();
      this._onResize = () => this.update();

      this.prevBtn.addEventListener('click', this._onPrev);
      this.nextBtn.addEventListener('click', this._onNext);
      this.track.addEventListener('scroll', this._onScroll, { passive: true });

      if ('ResizeObserver' in window) {
        this._ro = new ResizeObserver(this._onResize);
        this._ro.observe(this.track);
      } else {
        window.addEventListener('resize', this._onResize);
      }

      this.update();
      // Görseller yüklendikçe scrollWidth değişebilir
      window.addEventListener('load', this._onResize, { once: true });
    }

    disconnectedCallback() {
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this._onPrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this._onNext);
      if (this.track) this.track.removeEventListener('scroll', this._onScroll);
      if (this._ro) this._ro.disconnect();
      window.removeEventListener('resize', this._onResize);
    }

    scrollByStep(direction) {
      var step = Math.max(this.track.clientWidth * 0.8, 100);
      this.track.scrollBy({ left: direction * step, behavior: 'smooth' });
    }

    update() {
      var track = this.track;
      var hasOverflow = track.scrollWidth > track.clientWidth + 1;

      this.prevBtn.hidden = !hasOverflow;
      this.nextBtn.hidden = !hasOverflow;
      if (!hasOverflow) return;

      var maxScroll = track.scrollWidth - track.clientWidth;
      this.prevBtn.disabled = track.scrollLeft <= 2;
      this.nextBtn.disabled = track.scrollLeft >= maxScroll - 2;
    }
  }

  customElements.define('bbg-category-circles', BbgCategoryCircles);
})();
